// @flow
import { APP_NAME, PRODUCT_NAME } from '../constants/enums';

export const getDefaultCountry = () => {
  switch (APP_NAME) {
    case PRODUCT_NAME.BUYGRO:
      return 'ae';
    case PRODUCT_NAME.DIGITALSAATHI:
    case PRODUCT_NAME.DISTIMAN:
    case PRODUCT_NAME.GENIEE:
      return 'in';
    case PRODUCT_NAME.BIDCO:
      return 'ke';
    case PRODUCT_NAME.STONESLANE:
      return 'ye';
    default:
      return '';
  }
};
